// extracted by mini-css-extract-plugin
export default {"new-button":"new-button---iKhuU"};